<template>
  <div class="chat-container">
    <header class="chat-header">
      <div class="header-content">
        <Button label="view schema" icon="pi pi-arrow-right" iconPos="right" class="bg-blue-500 ButtonL"
          @click="showSchema = true" />
        <Button label="view historical SQLs" icon="pi pi-arrow-left" iconPos="left" class="bg-blue-400 ButtonR"
          @click="showHistory = true" />
        <h1>ChatQPT</h1>
      </div>
    </header>
    <div class="chat-messege" ref="chatRoom">
      <div class="message" v-for="(message, index) in messegeShow" :key="index">
        <!-- 添加头像元素 -->
        <img v-if="message.type === 'received'" src="../assets/chatbot.svg" class="avatar received-avatar" />
        <img v-if="message.type === 'sent'" src="../assets/user.svg" class="avatar sent-avatar" />

        <!-- 消息内容 -->
        <div :class="['message-content', message.type]">
          <!-- 展示文本内容 -->
          <div class="message-text" v-html="message.text"></div>
          <!-- 展示表格(ARENA) -->
          <div class="card" style="margin-top: 10px; margin-bottom: 15px;" v-if="'table' in message">
            <DataTable :value="message.table" stripedRows tableStyle="min-width: 50rem" paginator :rows="5">
              <Column field="id" header="Id"></Column>
              <Column field="c_dist" header="S_dist"></Column>
              <Column field="s_dist" header="C_dist"></Column>
              <Column field="cost" header="Cost"></Column>
              <Column field="relevance" header="Relevance"></Column>
            </DataTable>
          </div>

          <!-- 展示Plan tree的按钮 -->
          <div class="button-container"
            v-if="message.type === 'received' && message.system !== 'GPT' && 'planTree' in message">
            <Button label="Click here to view" @click="showTree[index] = true" severity="info" class="p-m-auto" />
          </div>

          <div class="message-time">{{ message.time }}</div>

        </div>

        <!-- 展示plan tree -->
        <Dialog v-model:visible="showTree[index]" maximizable modal header="Plan Tree Visualization"
          :style="{ width: '50rem' }" @hide="reset_select()" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
          <Dropdown v-model="selectTree" :options="message.planTreeIndex" placeholder="choose a plan"
            class="w-full md:w-12rem" v-if="message.system !== 'LANTERN'" />
          <OrganizationChart :value="message.planTree[selectTree]"
            v-if="message.type === 'received' && message.system !== 'GPT'">
            <template #default="slotProps">
              <span
                v-tooltip="{ value: slotProps.node.title, escape: false, pt: { text: 'bg-surface-800 font-medium text-center' }, hideDelay: 50 }"
                v-html="slotProps.node.name"></span>
            </template>
          </OrganizationChart>
        </Dialog>

      </div>
    </div>
    <div class="chat-input">
      <textarea v-model="newMessage" @keydown.enter="handleKeydown" placeholder="Message ChatQPT.." rows="6" class="chat-textarea" />
      <button @click="sendMessage" style="margin: 4px;">Send</button>
    </div>

    <!-- 展示Schema -->
    <Sidebar v-model:visible="showSchema" header="TPC-H Schema" dismissable="false"
      class="w-full md:w-20rem lg:w-30rem">
      <div class="card flex justify-content-center">
        <Tree :value="tpch_schema" class="w-full md:w-30rem"></Tree>
      </div>
    </Sidebar>

    <!-- 展示历史SQL -->
    <Sidebar v-model:visible="showHistory" header="historical SQLs" dismissable="false" position="right"
      class="w-full md:w-20rem lg:w-30rem">
      <div style="display: flex; flex-direction: column; height: 89vh;">
        <div style="overflow-y: auto; flex-grow: 1;">
          <div v-for="(sql, index) in historySQL" :key="index"
            :title="'Click to execute the SQL using the last parameter'" class="sql-item" @click="executeSQL(sql)">
            <span class="sql-index">{{ index + 1 }}.</span>
            <span v-html="highlightSQL(sql)"></span>
          </div>
        </div>
        <div class="input-container">
          <textarea class="input-box" v-model="newsql"
            placeholder="Please enter the SQL you want to query with the last query parameters"></textarea>
          <button class="submit-button" @click="executeSQL(newsql)">Submit</button>
        </div>
      </div>
    </Sidebar>

  </div>
</template>

<script>
  import { ref, reactive, getCurrentInstance, nextTick, watch } from "vue";

  export default {
    mounted() {
      const message = {
        text: "Hello, I'm ChatQPT. You can ask me any questions related to relational query processing.",
        time: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
        type: "received",
      };
      this.messegeShow.push(message);
    },
    setup() {
      const messegeShow = reactive([]); //存储用于展示的消息,包含用户输入的消息和chatDBEDU的回应
      const newMessage = ref(""); //存储用户在输入框输入的信息
      const messageReceived = reactive([]); //记录后端返回的数据,用于关联回答
      const historyMessages = reactive([]); // 结构化历史：[{role, content}]， 存储用户提交的全部问题,发送给后端生成回应
      const instance = getCurrentInstance(); //组合式api不具有上下文消息,需要导入api的baseurl与header设置
      const axios = instance.appContext.config.globalProperties.$axios;  //简化axios的表达

      const showTree = reactive([]);  //用于索引每个消息中的button,控制时候展示对应消息中的plantree
      const selectTree = ref('QEP');  //默认从QEP开始展示
      const tpch_schema = reactive([{ 'children': [{ 'label': 'c_custkey (integer)' }, { 'label': 'c_label (character varying)' }, { 'label': 'c_address (character varying)' }, { 'label': 'c_nationkey (integer)' }, { 'label': 'c_phone (character)' }, { 'label': 'c_acctbal (numeric)' }, { 'label': 'c_mktsegment (character)' }, { 'label': 'c_comment (character varying)' }], 'label': 'customer', 'key': '0' }, { 'children': [{ 'label': 'l_orderkey (integer)' }, { 'label': 'l_partkey (integer)' }, { 'label': 'l_suppkey (integer)' }, { 'label': 'l_linenumber (integer)' }, { 'label': 'l_quantity (numeric)' }, { 'label': 'l_extendedprice (numeric)' }, { 'label': 'l_discount (numeric)' }, { 'label': 'l_tax (numeric)' }, { 'label': 'l_returnflag (character)' }, { 'label': 'l_linestatus (character)' }, { 'label': 'l_shipdate (date)' }, { 'label': 'l_commitdate (date)' }, { 'label': 'l_receiptdate (date)' }, { 'label': 'l_shipinstruct (character)' }, { 'label': 'l_shipmode (character)' }, { 'label': 'l_comment (character varying)' }], 'label': 'lineitem', 'key': '1' }, { 'children': [{ 'label': 'n_nationkey (integer)' }, { 'label': 'n_label (character)' }, { 'label': 'n_regionkey (integer)' }, { 'label': 'n_comment (character varying)' }], 'label': 'nation', 'key': '2' }, { 'children': [{ 'label': 'o_orderkey (integer)' }, { 'label': 'o_custkey (integer)' }, { 'label': 'o_orderstatus (character)' }, { 'label': 'o_totalprice (numeric)' }, { 'label': 'o_orderdate (date)' }, { 'label': 'o_orderpriority (character)' }, { 'label': 'o_clerk (character)' }, { 'label': 'o_shippriority (integer)' }, { 'label': 'o_comment (character varying)' }], 'label': 'orders', 'key': '3' }, { 'children': [{ 'label': 'p_partkey (integer)' }, { 'label': 'p_label (character varying)' }, { 'label': 'p_mfgr (character)' }, { 'label': 'p_brand (character)' }, { 'label': 'p_type (character varying)' }, { 'label': 'p_size (integer)' }, { 'label': 'p_container (character)' }, { 'label': 'p_retailprice (numeric)' }, { 'label': 'p_comment (character varying)' }], 'label': 'part', 'key': '4' }, { 'children': [{ 'label': 'ps_partkey (integer)' }, { 'label': 'ps_suppkey (integer)' }, { 'label': 'ps_availqty (integer)' }, { 'label': 'ps_supplycost (numeric)' }, { 'label': 'ps_comment (character varying)' }], 'label': 'partsupp', 'key': '5' }, { 'children': [{ 'label': 'r_regionkey (integer)' }, { 'label': 'r_label (character)' }, { 'label': 'r_comment (character varying)' }], 'label': 'region', 'key': '6' }, { 'children': [{ 'label': 's_suppkey (integer)' }, { 'label': 's_label (character)' }, { 'label': 's_address (character varying)' }, { 'label': 's_nationkey (integer)' }, { 'label': 's_phone (character)' }, { 'label': 's_acctbal (numeric)' }, { 'label': 's_comment (character varying)' }], 'label': 'supplier', 'key': '7' }]);
      const showSchema = ref(false);
      const chatRoom = ref(null);        //用于更新聊天框位置
      const showHistory = ref(false);    //控制button展示历史查询SQL
      const historySQL = reactive([]);   //保存历史SQL
      const lastQuery = reactive({});    //保存最后一次的查询参数 
      const newsql = ref("")             //存储用户想用最后一次查询参数进行查询的SQL

      watch(        //监控message变化，当存在新消息到来时，滚动到最底部
        () => messegeShow.length,
        () => {
          nextTick(() => {
            chatRoom.value.lastElementChild.scrollIntoView();
          });
        }
      );

      // 获取全局的 hljs 实例
      const hljs = getCurrentInstance().appContext.config.globalProperties.$hljs;

      // 定义高亮函数
      const highlightSQL = (sql) => {
        return hljs.highlight(sql, { language: 'sql' }).value;
      };

      const handleKeydown = (event) => {
        if (event.key === "Enter" && !event.shiftKey) {
          event.preventDefault();        // 阻止换行
          sendMessage();
        }
      };

      const reset_select = () =>  //作为关闭dialog调用的函数,关闭dialog后会把要展示的计划指针指向QEP.不用额外设置isable=flase,这是关闭dialog的默认行为
      {
        selectTree.value = 'QEP';
      }

      function containsChineseCharacters(str) {
        const regex = /[\u4e00-\u9fa5]/; // 匹配汉字的正则表达式
        return regex.test(str); // 使用 test 方法判断是否有汉字
      }

      const executeSQL = (sql) => {
        sql = sql.trim();
        if (!sql) return;

        const displayMsg = {
          text: containsChineseCharacters(sql) ? "使用最后一次查询的参数查询这条SQL:" + sql : "Query this SQL using the parameters of the last query:" + sql,
          time: new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
          type: "sent",
        };

        showTree.push(false);  //用于索引一条信息中的tree时候展示,默认都为false,向messageShow中添加一条消息就需要添加一个boolen
        messegeShow.push(displayMsg);  //将消息加入到用于展示的消息列表中

        lastQuery.SQL = sql;
        if (!historySQL.includes(sql)) {
          historySQL.push(sql);
        }

        const stmt = {
          question: sql,
          history: [...historyMessages],
        };

        axios.post("chatdb/lastQuery", {
          statement: stmt,
          email: localStorage.getItem("email"),
        })
          .then((response) => {    //处理正常相应的情况
            const reply = {
              text: response.data["text"],
              time: new Date().toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              }),
              type: "received",
              system: response.data["system"] || "GPT",
            };

            if ("planTree" in response.data) {
              reply["planTree"] = response.data["planTree"];
              reply["planTreeIndex"] = response.data["planTreeIndex"];
              if ("table" in response.data) {
                reply["table"] = response.data["table"];
              }
              if (!reply["planTreeIndex"].includes("QEP")) {
                reply["planTreeIndex"] = reply["planTreeIndex"].concat(messageReceived[messageReceived.length - 1]["planTreeIndex"]);
                reply["planTree"] = Object.assign({}, reply["planTree"], messageReceived[messageReceived.length - 1]["planTree"]);
                reply["table"] = messageReceived[messageReceived.length - 1]["table"].concat(reply["table"]);
              }
            }

            showTree.push(false);
            messegeShow.push(reply);
            messageReceived.push(reply);

            if ("history" in response.data) {
              historyMessages.length = 0;
              historyMessages.push(...response.data["history"]);
            }
          })
          .catch((err) => {
            pushBackendErrorAsMessage(err);
          });
        showHistory.value = false;  //关闭history窗口,清空textarea中的内容
        newsql.value = "";
      };

      const sendMessage = () => {
        const currentText = newMessage.value.trim();
        if (!currentText) return;

        const userMsg = {
          text: currentText,
          time: new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
          type: "sent",
        };

        showTree.push(false);
        messegeShow.push(userMsg);

        const payload = {
          question: currentText,
          history: [...historyMessages],  // 启动阶段用旧历史发起
        };

        axios.post("chatdb/chat", {
          statement: payload,
          email: localStorage.getItem("email"),
        })
          .then((response) => {
            const reply = {
              text: response.data["text"],
              time: new Date().toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              }),
              type: "received",
              system: response.data["system"] || "GPT",
            };

            if ("planTree" in response.data) {
              reply["planTree"] = response.data["planTree"];
              reply["planTreeIndex"] = response.data["planTreeIndex"];
              if ("table" in response.data) {
                reply["table"] = response.data["table"];
              }
              if (!reply["planTreeIndex"].includes("QEP")) {
                reply["planTreeIndex"] = reply["planTreeIndex"].concat(
                  messageReceived[messageReceived.length - 1]["planTreeIndex"]
                );
                reply["planTree"] = Object.assign(
                  {},
                  reply["planTree"],
                  messageReceived[messageReceived.length - 1]["planTree"]
                );
                reply["table"] = messageReceived[messageReceived.length - 1][
                  "table"
                  ].concat(reply["table"]);
              }
            }

            showTree.push(false);
            messegeShow.push(reply);
            messageReceived.push(reply);

            // ✅ 用后端返回的 history 完全覆盖本地历史
            if ("history" in response.data) {
              historyMessages.length = 0;
              historyMessages.push(...response.data["history"]);
            }

            // ✅ 更新 lastQuery 中的 SQL 和参数（用于后续 executeSQL）
            if ("ask" in response.data) {
              Object.assign(lastQuery, response.data["ask"]);
              lastQuery.SQL = lastQuery.SQL?.trim?.();
              if (lastQuery.SQL && !historySQL.includes(lastQuery.SQL)) {
                historySQL.push(lastQuery.SQL);
              }
            }
          })
          .catch((err) => {
            pushBackendErrorAsMessage(err);
          });

        newMessage.value = "";
      };

      const parseBackendError = (err) => {
        if (!err || !err.response) return null; // 网络错误
        let data = err.response.data;
        // 有些后端没设 Content-Type，会变成字符串，这里兜底 parse 一下
        if (typeof data === "string") {
          try { data = JSON.parse(data); } catch (_) { /* ignore */ }
        }
        return data && typeof data === "object" ? data : null;
      };

      const pushBackendErrorAsMessage = (err) => {
        const data = parseBackendError(err);
        if (data && data.text) {
          messegeShow.push({
            text: data.text,
            time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
            type: "received",
            system: data.system || "SERVER",
          });
        } else {
          messegeShow.push({ text: "connect error, please retry later", time: "", type: "wrong" });
        }
      };

      return { newsql, executeSQL, containsChineseCharacters, highlightSQL, lastQuery, messegeShow, newMessage, sendMessage, showTree, selectTree, reset_select, showSchema, tpch_schema, chatRoom, showHistory, historySQL, handleKeydown };
    }
  };
</script>

<style scoped>
  .chat-container {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: #f9f9f9;
  }

  .chat-header {
    background-color: #3e90ec;
    color: white;
    padding: 10px;
  }

  .header-content {
    display: flex;
    align-items: center;
    justify-content: center;
    /* 使子元素居中 */
    text-align: center;
    position: relative;
    /* 为了绝对定位按钮 */
  }

  .header-content h1 {
    margin: 0;
    /* 移除标题的默认外边距 */
  }

  .header-content .ButtonL {
    position: absolute;
    /* 绝对定位按钮 */
    left: 10px;
    /* 将按钮放置在左侧 */
  }

  .header-content .ButtonR {
    position: absolute;
    right: 10px;
    /* 将按钮放置在右侧 */
  }


  .chat-messege {
    flex-grow: 1;
    overflow-y: auto;
    padding: 10px;
    background: #e5e5e5;
  }

  .message {
    display: flex;
    align-items: center;
  }

  .message-content {
    order: 1;
    padding: 10px;
    border-radius: 18px;
    margin: 5px;
    word-break: break-word;
    transition: all 0.3s ease-in-out;
    /* Smooth transition for better UX */
  }

  .message-content.sent {
    /* 发送消息样式 */
    background-color: #dcf8c6;
    margin-left: auto;
    text-align: left;
  }

  .message-content.received {
    /* 接收消息样式 */
    background-color: #ffffff;
    text-align: left;
  }

  .message-content.wrong {
    /* 错误消息样式 */
    color: red;
    font-weight: bold;
    margin: 0 auto;
    text-align: center;
  }

  .message-text {
    font-size: 1rem;
  }

  .message-time {
    font-size: 0.75rem;
    text-align: right;
    color: #999;
    margin-top: 5px;
  }

  .chat-input {
    display: flex;
    padding: 10px;
    background: #f0f0f0;
  }

  .chat-input input {
    flex-grow: 1;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .chat-input button {
    padding: 10px 20px;
    background-color: #32465a;
    color: white;
    border: none;
    border-radius: 18px;
    cursor: pointer;
    outline: none;
    transition: background-color 0.3s ease;
  }

  .chat-input button:hover {
    background-color: #365f8b;
  }

  .avatar {
    width: 40px;
    /* 头像大小 */
    height: 40px;
    border-radius: 50%;
    /* 圆形头像 */
    object-fit: cover;
  }

  .sent-avatar {
    margin-right: 10px;
    order: 2;
    /* 在消息框右边显示头像 */
  }

  .received-avatar {
    margin-left: 10px;
    order: 0;
    /* 在消息框左边显示头像 */
  }

  .button-container {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    margin: 5px;
  }

  .card {
    display: block;
  }

  .sql-item {
    margin-top: 10px;
    margin-bottom: 10px;
    /* 调整间距 */
    padding: 10px;
    /* 内边距，使内容不贴边 */
    border: 1px solid #ccc;
    /* 边框颜色和宽度 */
    border-radius: 5px;
    /* 圆角效果 */
    background-color: #f9f9f9;
    /* 背景色，突出分块 */
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    /* 阴影效果 */
    transition: transform 0.2s, box-shadow 0.2s;
    /* 动效提升用户体验 */
  }

  .sql-item:hover {
    transform: translateY(-2px);
    /* 鼠标悬停时微微上移 */
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    /* 悬停时增加阴影 */
  }

  .input-container {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    /* 按列排列 */
    padding: 16px;
    border-top: 1px solid #ccc;
    /* 分割线 */
    margin-top: auto;
  }


  .input-box {
    width: 100%;
    height: 150px;
    /* 固定高度 */
    padding: 8px;
    margin-bottom: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    resize: vertical;
    /* 允许用户调整高度 */
    overflow-y: auto;
    /* 当内容过多时显示滚动条 */
    font-size: 16px;
  }

  .submit-button {
    width: 100px;
    padding: 10px;
    font-size: 16px;
    color: #fff;
    background-color: #007bff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    align-self: center;
  }

  .submit-button:hover {
    background-color: #0056b3;
  }

  .chat-input {
    display: flex;
    padding: 10px;
    background: #f0f0f0;
  }

  .chat-textarea {
    flex: 1;                  /* 宽度自适应，填满按钮左侧 */
    margin-right: 8px;        /* 与 Send 按钮留出间距 */
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 1rem;
    height: 120px;             /* 四行左右，可自行调整 */
    resize: none;             /* 禁止用户拖拽改变大小 */
    overflow-y: auto;         /* 超过固定高度出现滚动条 */
    overflow-x: hidden;       /* 防止横向滚动 */
    box-sizing: border-box;   /* 包含内边距与边框 */
  }

  .chat-input button {
    padding: 0 24px;          /* 给按钮足够“呼吸空间” */
    line-height: 36px;        /* 与文本框行高保持协调 */
    background-color: #32465a;
    color: white;
    border: none;
    border-radius: 18px;
    cursor: pointer;
    outline: none;
    transition: background-color 0.3s ease;
  }

  .chat-input button:hover {
    background-color: #365f8b;
  }

</style>